export const configComponentTypes: { [key: string]: any } = {};

export function ConfigComponent(name: string) {
    console.log('configcomponent decorator 1', name);
    return function (ctr: any): any {
        console.log('configcomponent decorator 2', name);
        configComponentTypes[name] = ctr;
    };
}
